import { AxiosError } from "axios";
import { getErrorMessage } from "utils/error";

const FEED_ERROR_MESSAGES: Record<string, string> = {
  integration_not_connected:
    "Connect this integration before adding listings to its feed.",
  unconfigured_feature: "This feature isn't available for your account.",
  feed_apartments_com_variant_required:
    "Select a property type before adding to the Apartments.com feed.",
  invalid_zillow_variant: "Select Single family or Multi family for Zillow.",
  feed_zillow_variant_requires_zillow:
    "Add this listing to the Zillow feed before choosing its type.",
  cannot_enable_feed_on_unlisted_unit:
    "List this unit before adding it to the feed.",
  missing_landlord_email:
    "Add a Landlord email in Settings > Branding before connecting this integration."
};

export const getFeedErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const code = error.response?.data?.error;
    if (typeof code === "string" && FEED_ERROR_MESSAGES[code])
      return FEED_ERROR_MESSAGES[code];
    if (error.response?.status === 404)
      return "This unit isn't available to add to the feed.";
  }

  return getErrorMessage(error);
};
